module.exports = __webpack_public_path__ + "img/phone_140.09d6cacd.jpg";